module.exports = require('./readable').Transform



//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/emr-webapp/~/readable-stream/transform.js
// module id = ../../../../readable-stream/transform.js
// module chunks = 5